$(document).ready(function(){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
  }).on('afterChange', function( event, slick, currentSlide ) {
    var iframe = $(slick.$slides[currentSlide]).find('iframe');
    var videoSlide = iframe.length;
    if(videoSlide) {
      iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    }else{
      $('.youTubeVideo').each(function(){
        $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
    }
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows:true,
    centerMode: true,
    focusOnSelect: true
  });
});

